<template lang="pug">
    div.classMenu
        van-tabs(:active="active", swipe-threshold=3, @click="tabChange", ref="classMenu")
            van-tab(v-for="item in menuList", :title="item.title", :name="item.name")
                router-view
</template>

<script>
export default {
    name: 'ClassMenu',
    data(){
        return {
            active:"weapon",
            menuList:[]
        }
    },
    created(){
        this.active = this.$route.path.split("/")[1]
    },
    methods:{
        tabChange(data) {
            let path = this.$route.path.split("/")[1]
            if(path != data){
                this.$router.push({
                    path: "/"+data
                })
            }
        },
        language() {
            if(CONFIG.env == 'cn'){
                window.localStorage.setItem('language', 'zh-CN')
                window.i18n.locale = 'zh-CN'
            } else {
                window.localStorage.setItem('language', this.$route.query.lang || window.localStorage.getItem('language') || 'en-US')
                window.i18n.locale = this.$route.query.lang || window.localStorage.getItem('language') || 'en-US'
                this.pageLang = this.$route.query.lang || window.localStorage.getItem('language') || 'en-US'
            }
        }
    },
    computed:{

    },
    mounted(){
        this.language()
        this.menuList = [{
            title:this.$t("menuList.weapon"),
            name:"weapon"
        },{
            title:this.$t("menuList.weaponMod"),
            name:"weaponMod"
        },{
            title:this.$t("menuList.hero"),
            name:"hero"
        },{
            title:this.$t("menuList.chip"),
            name:"chip"
        },{
            title:this.$t("menuList.wall"),
            name:"wall"
        }]
    },
    watch: {
        $route(to, from) {
            this.active = this.$route.path.split("/")[1]
            this.$refs.classMenu.resize()
        },
    }
}
</script>

<style lang="scss">
.classMenu {
    .van-tab {
        align-items:normal;
        line-height: 46px;
    }
    .van-tabs--line .van-tabs__wrap {
        width: 100%;
        height: 59.64px;
        background: url("../assets/class_bg.png") center top no-repeat;
        background-size: cover;
    }
    .van-tabs__nav {
        background-color: transparent;
    }
    .van-tabs__nav--line {
        padding-bottom: 0px;
    }
    .van-tab {
        font-size: 20px;
    }
    .van-tab--active {
        color: #f0d48f;
    }
    .van-tabs__line {
        background-color: #f0d48f;
        border-radius: 0px;
        bottom: 18px;
        z-index: 0;
    }
}
</style>